var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchase1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.25H13.5V3C13.5 2.80109 13.421 2.61032 13.2803 2.46967C13.1397 2.32902 12.9489 2.25 12.75 2.25H2.25C2.05109 2.25 1.86032 2.32902 1.71967 2.46967C1.57902 2.61032 1.5 2.80109 1.5 3V13.5C1.5 14.7405 2.5095 15.75 3.75 15.75H14.25C15.4905 15.75 16.5 14.7405 16.5 13.5V9C16.5 8.80109 16.421 8.61032 16.2803 8.46967C16.1397 8.32902 15.9489 8.25 15.75 8.25ZM3.75 14.25C3.55109 14.25 3.36032 14.171 3.21967 14.0303C3.07902 13.8897 3 13.6989 3 13.5V3.75H12V13.5C12 13.7633 12.0457 14.016 12.1283 14.25H3.75ZM15 13.5C15 13.6989 14.921 13.8897 14.7803 14.0303C14.6397 14.171 14.4489 14.25 14.25 14.25C14.0511 14.25 13.8603 14.171 13.7197 14.0303C13.579 13.8897 13.5 13.6989 13.5 13.5V9.75H15V13.5Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.25H10.5V6.75H4.5V5.25ZM4.5 8.25H10.5V9.75H4.5V8.25ZM8.25 11.25H10.5V12.75H8.25V11.25Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase1);
export default __webpack_public_path__ + "static/media/purchase1.d8891c96f79bde0d309fb5554270984a.svg";
export { ForwardRef as ReactComponent };